export default {
  key: process.env.REACT_APP_KEY,
  baseURL: process.env.REACT_APP_BASE_URL,
  baseURLWD: process.env.REACT_APP_BASE_URL_WILL_DOTS,
  enableGTM: process.env.REACT_APP_ENABLE_GTM_TRACKING,
  GTM: process.env.REACT_APP_GTM_TRACKING_ID,
  baseURLHS: process.env.REACT_APP_BASE_URL_HUBSPOT,
};
